import React from 'react';
import lab from '../assets/img/portfolio/main.png';
import landing from '../assets/img/Picture_2.png';
import landing2 from '../assets/img/pic_4.png';
import 'bootstrap';
import 'aos';
import hero from '../assets/img/portfolio/hero-img.png'
import { Link as RouterLink } from 'react-router-dom';
import SaaSFrame from './SaaSFrame';
import ContactUs from './ContactUs';
import CustomerLogos from './CustomerLogos';
import ScrollingComponent from './ScrollingComponent';
import IntegratedSolutions from './IntegratedSolutions';
import Testimonials from './Testimonials';
import ComplianceStandards from './ComplianceStandards';
import TLimsFrame from './TLimsFrame';

const Home = () => {
    const sectionStyle = {
        backgroundImage: `url(${landing})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center', 
        width: '100%',
        lineHeight: '1', 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden'
    };

    return (
        <React.Fragment>
            <div id='HOME'>
                <section id='hero' style={sectionStyle}> 
                    <div id="heroCarousel" className="container carousel carousel-fade" data-bs-ride="carousel">
                        <div className="row carousel-item active d-flex flex-row justify-content-start" >
                            <div className="carousel-container col-12 col-lg-6">
                                <h1 className="animate__animated animate__fadeInDown text-light text-start home-title" ><b>Elevate Your Lab's Efficiency with Intuitive Compliance Solutions</b></h1>
                            
                                {/* <a href="https://www.youtube.com/watch?v=Oj1V55eBSKU" target="_blank" rel='noreferrer' className="btn-get-started animate__animated animate__fadeInUp scrollto"><b>Watch Video</b></a> */}
                                <RouterLink  className='routerLink btn-get-started animate__animated animate__fadeInUp scrollto' to='/demo' href="#REQUEST A DEMO" target="" ><b>Get a Demo</b></RouterLink>
                            </div>
                            <div className="carousel-container col-12 col-lg-6 animate__animated animate__fadeInDown" data-aos="zoom-in" data-aos-delay="200">
                                {/* <img src={hero} alt="Labiconics Logo" className="img-fluid animated" /> */}
                            </div>
                        </div>
                    </div>

                </section>
            </div>
            <CustomerLogos />
            <ScrollingComponent />
            <ComplianceStandards />
            <TLimsFrame />
            <IntegratedSolutions />
            <SaaSFrame />
            {/* <Testimonials /> */}
            <ContactUs />
        </React.Fragment>
    );
};

export default Home;
